




































































































import { BaseFiltroPagDTO, PaginationSyncDTO } from '@/interfaces/base-dto';
import { findNotificationsReadingPage } from '@/services/notification';
import { getLocalBusinessUnit, getLocalClient, isPopupLoginShown, setPopupLoginShown } from '@/services/session-data';
import Component from 'vue-class-component';
import BaseComponent from '../base-component.vue';
import NotificationDialog from './notification-dialog.vue';
import NotificationPrescriptionDialog from './notification-prescription-dialog.vue';

@Component({
  components: {
    NotificationDialog,
    NotificationPrescriptionDialog
  },
})
export default class NotificationMenu extends BaseComponent {
  unreadOnly = false;

  menu = false;
  showDialog = false;
  showBadge = false;
  unreadCount = 0;
  unreadCountStr = '0';
  itens = new Array();
  idNotifSelec = null;
  tipoNotifSelec = null;

  pagination:PaginationSyncDTO = new PaginationSyncDTO()
  loading = false;
  showLoading = false;

  loadNotificationsTimeout = 2 * 60 * 1000;
  loadNotificationsInterval = null;
  mounted() {
    this.pagination.rowsPerPage = 10;
    this.loadNotifications();
    this.loadNotificationsInterval = setInterval(() => {
      this.loadNotifications();
    }, this.loadNotificationsTimeout);
  }

  beforeDestroy() {
    clearInterval(this.loadNotificationsInterval);
  }

  loadNotifications() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    let filtro = new BaseFiltroPagDTO();
    filtro.update(this.pagination);

    findNotificationsReadingPage(filtro).subscribe(
      (res) => {
        this.itens = res.content;
        PaginationSyncDTO.update(this.pagination, res);
        let count = this.itens.filter((i) => !i.lido && !i.expirado).length;
        this.unreadCount = count;
        if (count > 9) {
          this.unreadCountStr = '9+';
        } else {
          this.unreadCountStr = String(count);
        }
        this.showBadge = this.unreadCount > 0;
        this.showLoading = false;
        this.loading = false;

        this.prepareShowPopup();
      },
      (error) => {
        this.showLoading = false;
        this.loading = false;
      },
    );
  }

  prepareShowPopup() {
    if (!getLocalBusinessUnit() || isPopupLoginShown()) {
      return;
    }

    if (!this.isEmede() && !this.isDoctor() && !getLocalClient()) {
      // Usuario cliente, aguardar escolher a unidade cliente
      return;
    }

    let itemPopup = this.itens.find(n => n.popup && !n.lido && !n.expirado);
    if (!itemPopup ) {
      return;
    }
    this.onMessageClick(itemPopup);
    setPopupLoginShown(true);
  }

  getItensShow() {
    if (this.unreadOnly) {
      return this.itens.filter((i) => !i.lido);
    } else {
      return this.itens;
    }
  }

  onMessageClick(item) {
    this.idNotifSelec = item.id;
    this.tipoNotifSelec = item.tipo.id;
    this.showDialog = true;
    this.menu = false;
    setTimeout(() => {
      this.loadNotifications();
    }, 5000);
  }

  onMessageClose(item) {
    this.showDialog = false;
  }

  loadMore() {
    if (this.showLoading || !this.itens.length || this.itens.length == this.pagination.totalItems) {
      return;
    }
    this.pagination.rowsPerPage = this.pagination.rowsPerPage.valueOf() + 10;
    this.showLoading = true;
    this.loadNotifications();
  }
}
